<template>
  <div class="relative">
    <!-- Opener -->
    <button class="metric-opener flex items-center pr-1 py-1 rounded-md"
    :class="[{'active': showMetricSelector, 'use-shadow': shadow}, color.length ? 'pl-2' : 'pl-3']" 
    :disabled="disableSelector"
    @click="showMetricSelector = !showMetricSelector">
      <div v-if="color.length" class="w-2 h-2 rounded-sm mr-1.5" :style="{backgroundColor: color}" />
      <BaseText type="label" size="sm" class="text-text-muted mr-0.5">
        {{ metricName }}
      </BaseText>
      <div v-if="!disableSelector" class="transform transition-transform" :style="{ transform: showMetricSelector ? 'scaleY(-1)' : 'scaleY(1)' }">
        <ChevronIcon className="text-icon-normal" />
      </div>
    </button>
    <!-- Dropdown -->
    <transition>
      <div v-if="showMetricSelector" class="select-metric-dropdown" v-on-clickaway="() => { showMetricSelector = false }"
      :class="side === 'left' ? 'left-0' : 'right-0'">
        <PropertySelectDropdown 
          search-placeholder="Search Metrics"
          metrics-only
          emit-keys-only
          :excluded-categories="['foreplay_metrics', 'tags']"
          :selections="[selectedMetric]"
          @optionSelected="handleMetricChange"
          @close="showMetricSelector = false"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway2'
import PropertySelectDropdown from '@/components/lens/filters/PropertySelectDropdown.vue'
import ChevronIcon from '@/components/globals/Icons/ChevronIcon.vue'

export default {
  name: 'GraphMetricSelector',
  components: {
    ChevronIcon,
    PropertySelectDropdown
  },
  mixins: [clickaway],
  props: {
    selectedMetric: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: ''
    },
    side: {
      type: String,
      default: 'left'
    },
    shadow: {
      type: Boolean,
      default: true
    },
    disableSelector: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showMetricSelector: false
    }
  },
  computed: {
    ...mapGetters('MetricsModule', ['getMetricLookup']),
    metricName () {
      const fullName = this.getMetricLookup?.[this.selectedMetric]?.name
      if (!fullName) return this.selectedMetric
      return fullName.split('(')[0].trim() // Remove any parentheses and their contents
    },
  },
  methods: {
    handleMetricChange (metricKey) {
      this.$emit('changeMetric', metricKey)
      this.showMetricSelector = false
    }
  }
}
</script>

<style scoped>
.metric-opener {
  background-color: white;
  transition: box-shadow 100ms ease-in-out, background-color 100ms ease-in-out;
}
.metric-opener.use-shadow {
  box-shadow: 0 1px 2px 0 rgba(4, 26, 75, 0.13), 0 0 0 1px rgba(0, 56, 108, 0.08);
}
.metric-opener.use-shadow:hover {
  background-color: white;
  box-shadow: 0 1px 2px 0 rgba(4, 26, 75, 0.17), 0 0 0 1px rgba(0, 56, 108, 0.12);
}
.metric-opener:hover:not(:disabled) {
  background-color: #F6F8FA;
}
.metric-opener:disabled {
  cursor: default;
}
.metric-opener.active, .metric-opener.active:hover {
  box-shadow: none;
  background-color: #F6F8FA;
}

.select-metric-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  z-index: 500;
}

.v-enter-active, .v-leave-active {
  transition: opacity 100ms ease-in-out;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
</style>